import dynamic from 'next/dynamic';
import { type HTMLProps } from 'react';

import { logger as browserLogger } from '@/logger/logger.browser';

import { SvgName } from './types';

// map of svg names to img file name
const SVG_IMG: Record<SvgName, string> = {
  cigna: 'cigna-logo',
  essence: 'essence-logo',
  'green-circle-check': 'green-circle-check',
  'olympics-team-usa': 'olympics-team-usa-logo',
};

const getSvgImg = (name: SvgName): JSX.Element | null => {
  const svgImgFile = SVG_IMG[name];

  if (!svgImgFile) {
    browserLogger.warn('Missing SVG name', { name });
    return null;
  }

  const SvgImg = dynamic<HTMLProps<SVGElement>>(
    () => import(`./img/${svgImgFile}.svg`),
  );

  return <SvgImg />;
};

export default getSvgImg;
